import map from "lodash/map";
import capitalize from "lodash/capitalize";

// Example: ['MONDAY', 'TUESDAY'] => ['Monday', 'Tuesday']
export const firstLetterUpperCaseList = (
  items: { id: string; value: string }[]
) => map(items, (item) => capitalize(item.value));
